// import React, { useEffect, useState } from 'react';
// import API from '../api/axios';

// const AdminCategory = () => {
//   const [categories, setCategories] = useState([]);
//   const [newCategory, setNewCategory] = useState({ name: '', label: '' });
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState('');

//   const fetchCategories = async () => {
//     try {
//       const res = await API.get('/categories');
//       setCategories(res.data);
//     } catch (err) {
//       setError('Failed to fetch categories');
//     }
//   };

//   const addCategory = async () => {
//     if (!newCategory.name || !newCategory.label) return setError('Both fields required');
//     setLoading(true);
//     try {
//       const res = await API.post('/categories', newCategory);
//       setCategories(prev => [...prev, res.data]);
//       setNewCategory({ name: '', label: '' });
//       setError('');
//     } catch (err) {
//       setError(err.response?.data?.error || 'Failed to add category');
//     }
//     setLoading(false);
//   };

//   const deleteCategory = async (name) => {
//     const confirm = window.confirm(`Delete category "${name}"?`);
//     if (!confirm) return;

//     try {
//       await API.delete(`/api/categories/${name}`);
//       setCategories(prev => prev.filter(c => c.name !== name));
//     } catch (err) {
//       alert('Failed to delete category');
//     }
//   };

//   useEffect(() => {
//     fetchCategories();
//   }, []);

//   return (
//     <div className="p-6 max-w-3xl mx-auto">
//       <h1 className="text-2xl font-bold mb-4">Category Management</h1>

//       {/* Add New Category */}
//       <div className="bg-white shadow-md p-4 rounded mb-6">
//         <h2 className="text-xl mb-2">Add New Category</h2>
//         {error && <p className="text-red-600 mb-2">{error}</p>}
//         <div className="grid grid-cols-2 gap-4 mb-3">
//           <input
//             type="text"
//             placeholder="Category Name (e.g., readymade)"
//             value={newCategory.name}
//             onChange={e => setNewCategory({ ...newCategory, name: e.target.value })}
//             className="border p-2 rounded"
//           />
//           <input
//             type="text"
//             placeholder="Label (e.g., Readymade Projects)"
//             value={newCategory.label}
//             onChange={e => setNewCategory({ ...newCategory, label: e.target.value })}
//             className="border p-2 rounded"
//           />
//         </div>
//         <button
//           onClick={addCategory}
//           disabled={loading}
//           className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded"
//         >
//           {loading ? 'Adding...' : 'Add Category'}
//         </button>
//       </div>

//       {/* Category List */}
//       <div className="bg-white shadow-md p-4 rounded">
//         <h2 className="text-xl mb-3">Existing Categories</h2>
//         {categories.length === 0 ? (
//           <p>No categories available.</p>
//         ) : (
//           <ul className="divide-y">
//             {categories.map((cat) => (
//               <li key={cat.name} className="flex justify-between py-2">
//                 <span>
//                   <strong>{cat.label}</strong> ({cat.name})
//                 </span>
//                 <button
//                   onClick={() => deleteCategory(cat.name)}
//                   className="text-red-600 hover:underline"
//                 >
//                   Delete
//                 </button>
//               </li>
//             ))}
//           </ul>
//         )}
//       </div>
//     </div>
//   );
// };

// export default AdminCategory;


import React, { useEffect, useState } from 'react';
import API from '../api/axios';
import { Loader2, Trash2 } from 'lucide-react';
import '../style/AdminCategory.css';

const AdminCategory = () => {
  const [categories, setCategories] = useState([]);
  const [newCategory, setNewCategory] = useState({ name: '', label: '' });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const fetchCategories = async () => {
    try {
      const res = await API.get('/categories');
      setCategories(res.data);
    } catch {
      setError('Failed to fetch categories');
    }
  };

  const addCategory = async () => {
    if (!newCategory.name || !newCategory.label) {
      return setError('Both fields are required');
    }

    setLoading(true);
    try {
      const res = await API.post('/categories', newCategory);
      setCategories(prev => [...prev, res.data]);
      setNewCategory({ name: '', label: '' });
      setError('');
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to add category');
    }
    setLoading(false);
  };

  const deleteCategory = async (name) => {
    const confirm = window.confirm(`Delete category "${name}"?`);
    if (!confirm) return;

    try {
      await API.delete(`/categories/${name}`);
      setCategories(prev => prev.filter(c => c.name !== name));
    } catch {
      alert('Failed to delete category');
    }
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  return (
    <div className="admin-container">
      <div className="admin-inner">

        <h1 className="admin-title">Category Management</h1>

        <div className="admin-card">
          <h2 className="admin-subtitle">Add New Category</h2>
          {error && <div className="admin-error">{error}</div>}

          <div className="admin-input-group">
            <input
              type="text"
              placeholder="Category Name (e.g., readymade)"
              value={newCategory.name}
              onChange={(e) => setNewCategory({ ...newCategory, name: e.target.value })}
              className="admin-input"
            />
            <input
              type="text"
              placeholder="Label (e.g., Readymade Projects)"
              value={newCategory.label}
              onChange={(e) => setNewCategory({ ...newCategory, label: e.target.value })}
              className="admin-input"
            />
          </div>

          <button
            onClick={addCategory}
            disabled={loading}
            className={`admin-button ${loading ? 'disabled' : ''}`}
          >
            {loading ? <Loader2 className="loading-icon" /> : '+'}
            {loading ? 'Adding...' : 'Add Category'}
          </button>
        </div>

        <div className="admin-card">
          <h2 className="admin-subtitle">Existing Categories</h2>
          {categories.length === 0 ? (
            <p className="admin-empty">No categories available.</p>
          ) : (
            <ul className="admin-list">
              {categories.map((cat) => (
                <li key={cat.name} className="admin-list-item">
                  <div>
                    <p className="admin-cat-label">{cat.label}</p>
                    <p className="admin-cat-name">{cat.name}</p>
                  </div>
                  <button
                    onClick={() => deleteCategory(cat.name)}
                    className="admin-delete-button"
                    title="Delete"
                  >
                    <Trash2 size={18} />
                  </button>
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </div>
  );
};

export default AdminCategory;
